import { Customer, FetchCustomersDocument, FetchCustomersQuery, FetchCustomersQueryVariables } from "@/graphql/__generated__/graphql";
import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";

export const useFetchCustomersLazyQueryHook = () => {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [fetchCustomers, { data, loading, error }] = useLazyQuery<FetchCustomersQuery, FetchCustomersQueryVariables>(
    FetchCustomersDocument, {
      fetchPolicy: "network-only"
    });

  useEffect(() => {
    if (data) {
      setCustomers(data.fetchCustomers as Customer[]);
    }
  }, [data]);

  return {
    fetchCustomers,
    loading,
    error,
    customers
  };
};
